<template>
  <div id="copyright-documents-dialog">
    <ipub-model :title="`Manuscript No.: ${manuscript.code}`"
                width="1000px"
                class="copyright-documents"
                :visable="isVisable"
                @cancel="cancel"
                :showFooter="false">
      <div class="copyright-documents-block mar-b-20">
        <div class="ipub-h3 ipub-title-tab line-h-40 ipub-title mar-b-10"
             @click="()=>{step1 = !step1}">
          <a>
            Manuscript Information
            <ipub-icon :class="['mar-l-10 rotate',step1?'rotate-180':'']"
                       type="iconArrow" />
          </a>
        </div>
        <div v-if="step1"
             class="ipub-title-tab-part ipub-p2">
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="ipub-p2 fw-bd "
                      :span="2">
              Journal
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.journal?manuscript.journal.name:'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="ipub-p2 fw-bd "
                      :span="2">
              Article Type
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details&&manuscript.details.type&&manuscript.details.type.name||'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="ipub-p2 fw-bd "
                      :span="2">
              Title
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details&&manuscript.details.title||'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="ipub-p2 fw-bd "
                      :span="2">
              Section
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details && manuscript.details.section && manuscript.details.section.name||'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="ipub-p2 fw-bd "
                      :span="2">
              Special Issue
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details && manuscript.details.special && manuscript.details.special.titleText || '--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="ipub-p2 fw-bd "
                      :span="2">
              Abstract
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details&&manuscript.details.summary||'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="ipub-p2 fw-bd "
                      :span="2">
              Keywords
            </ipub-col>
            <ipub-col :span="10">
              <template v-if="manuscript && manuscript.details &&manuscript.details.keyword">
                {{manuscript.details.keyword}}
              </template>
              <template v-else>--</template>
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Funding
            </ipub-col>
            <ipub-col :span="10">
              <template v-if="manuscript && manuscript.foundationList &&manuscript.foundationList.length>0">
                <div v-for="item in manuscript.foundationList"
                     :key="item.id">{{item.name}} <template v-if="item.code">({{item.code}})</template></div>
              </template>
              <template v-else>--</template>
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Discount
            </ipub-col>
            <ipub-col :span="10">
              <template v-if="manuscript && manuscript.discountDetailList &&manuscript.discountDetailList.length>0">
                <font>{{manuscript.__diacountTotal}} USD off</font>
              </template>
              <template v-else>--</template>
            </ipub-col>
          </ipub-row>
        </div>
      </div>
      <div class="mar-b-20 line-h-40">
        <div class="ipub-h3 ipub-title ipub-title-tab line-h-40 mar-b-10"
             @click="()=>{step2 = !step2}">
          <a>
            Author Information
            <ipub-icon :class="['mar-l-10 rotate',step2?'rotate-180':'']"
                       type="iconArrow" />
          </a>
        </div>
        <div v-if="step2"
             class="ipub-p2">
          <div class="border-top"
               v-for="item in manuscript.authorList"
               :key="item.id">
            <div class="mar-b-10">
              <span class=" fw-bd"> #{{item.seq}} {{title[item.titleCode]}} {{item.firstName}} {{item.lastName}}</span>
              <ipub-label v-if="item.submited"
                          size="small"
                          class="mar-l-20"
                          type="theme">
                Submitted Author
              </ipub-label>
              <ipub-label v-if="item.firsted"
                          size="small"
                          class="mar-l-10"
                          type="theme">
                First Author
              </ipub-label>
              <ipub-label v-if="item.corresponded"
                          size="small"
                          class="mar-l-10"
                          type="theme">
                Correspondence Author
              </ipub-label>
            </div>
            <ipub-row :gutter="[30, 12]">
              <ipub-col class="fw-bd "
                        :span="2">
                Email
              </ipub-col>
              <ipub-col :span="10">
                {{item.email}}
              </ipub-col>
            </ipub-row>
            <ipub-row :gutter="[30, 12]">
              <ipub-col class="fw-bd "
                        :span="2">
                Country / Terriory
              </ipub-col>
              <ipub-col :span="10">
                {{country[item.countryCode]}}
              </ipub-col>
            </ipub-row>
            <ipub-row :gutter="[30, 12]">
              <ipub-col class="fw-bd "
                        :span="2">
                <ipub-icon type="iconORCID"
                           style="color:#a6ce39"></ipub-icon>
                ORCID
              </ipub-col>
              <ipub-col :span="10">
                {{item.orcid}}
              </ipub-col>
            </ipub-row>
            <ipub-row :gutter="[30, 12]">
              <ipub-col class="fw-bd "
                        :span="2">
                Affiliation(s)
              </ipub-col>
              <ipub-col :span="10">
                {{item.affiliation}}
              </ipub-col>
            </ipub-row>
          </div>
        </div>
      </div>
      <div class="copyright-documents-block mar-b-20 line-h-40">
        <div class="ipub-h3 ipub-title ipub-title-tab line-h-40 mar-b-10"
             @click="()=>{step4 = !step4}">
          <a>
            Manuscript Files
            <ipub-icon :class="['mar-l-10 rotate',step4?'rotate-180':'']"
                       type="iconArrow" />
          </a>

        </div>
        <div v-if="step4"
             class="copyright-documents-block-content ipub-p2">
          <div class="mar-b-12"
               v-for="item in manuscript.fileList"
               :key="item.id">
            <ipub-row :gutter="30">
              <ipub-col class="ipub-p2 fw-bd "
                        :span="3">
                {{item.item?item.item.typeName:'--'}}
              </ipub-col>
              <ipub-col :span="9">
                <ipub-label style="margin: 0 16px 0 0;"><a class="link-color"
                     @click="downloadMfile(`${domain}/${item.path}`, item.name, item)"
                     target="_blank">{{item.name}}</a>
                  <ipub-icon v-if="item.loading"
                             class="mar-l-10"
                             type="loading" />
                  <ipub-icon v-else-if="item.progress === 100"
                             @click="downloadMfile(`${domain}/${item.path}`, item.name, item)"
                             class="mar-l-10 ipub-cursor-pointer success-color"
                             type="iconAble" />
                  <ipub-icon v-else
                             @click="downloadMfile(`${domain}/${item.path}`, item.name, item)"
                             class="mar-l-10 ipub-cursor-pointer link-color"
                             type="iconDownload1" />
                </ipub-label>
                <div class="ipub-block_font-downloading">
                  <div class="ipub-block_font-downloading-content"
                       v-if="item.loading"
                       :style="{width:item.progress+'%'}"></div>
                </div>
              </ipub-col>
            </ipub-row>
          </div>
        </div>
      </div>
      <div class="copyright-documents-block">
        <div class="ipub-h3 ipub-title ipub-title-tab line-h-40 mar-b-10"
             @click="()=>{step3 = !step3}">
          <a>
            Suggest & Oppose Reviewers
            <ipub-icon :class="['mar-l-10 rotate',step3?'rotate-180':'']"
                       type="iconArrow" />
          </a>

        </div>
        <div v-if="step3">
          <div class="flex">
            <div class="ipub-p2 fw-bd"
                 v-if="suggestList && suggestList.length>0">Suggest Reviewer</div>
            <div class="mar-l-20">
              <div v-for="(item,index) in suggestList"
                   :key="item.id+index"
                   class="mar-b-16">
                <div class="ipub-p2">{{item.firstName}} {{item.lastName}} ({{item.email}})</div>
                <span class="ipub-p2">{{item.affiliation}}</span>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="ipub-p2 fw-bd"
                 v-if="opposeList && opposeList.length>0">Oppose Reviewer</div>
            <div class="mar-l-20">
              <div v-for="(item,index) in opposeList"
                   :key="item.id+index"
                   class="mar-b-16">
                <div class="ipub-p2">{{item.firstName}} {{item.lastName}} ({{item.email}})</div>
                <span class="ipub-p2">{{item.affiliation}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import manuscript from '@/api/manuscript'
import help from '@/utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  data () {
    return {
      step4: true,
      step1: true,
      step2: true,
      step3: true,
      manuscript: {},
      download: help.download,
      suggestList: [],
      opposeList: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      title: 'getTitle',
      domain: 'getDomain',
      country: 'getCountry'
    })
  },
  watch: {
    isVisable: {
      handler (val) {
        if (val) {
          this.getQuery()
        }
      },
      immediate: true
    }
  },
  methods: {
    async getQuery () {
      this.manuscript = await manuscript.query(this.inputData.id)
      let disTotal = 0
      if (this.manuscript.discountDetailList && this.manuscript.discountDetailList.length > 0) {
        this.manuscript.discountDetailList.forEach(ele => {
          disTotal += ele['discount']
        })
        this.manuscript.__diacountTotal = disTotal
      }
      if (this.manuscript.reviewerList && this.manuscript.reviewerList.length > 0) {
        this.suggestList = this.manuscript.reviewerList.filter(item => {
          return item.type === 'SUGGEST'
        })
        this.opposeList = this.manuscript.reviewerList.filter(item => {
          return item.type === 'OPPOSE'
        })
      }

    },
    downloadMfile (url, name, val) {
      this.$set(val, 'loading', true)
      this.download(url, name, (progress) => {
        this.$set(val, 'progress', progress)
        if (progress === 100) {
          this.$set(val, 'loading', false)
          setTimeout(() => {
            this.$set(val, 'progress', 0)
          }, 2000);
        }
      })

    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
#copyright-documents-dialog {
  .border-top {
    border-top: 1px solid $line_color;
    padding: 10px 0;
    &:nth-child(1) {
      border-top: transparent;
    }
  }
  .ipub-title {
    color: $content_color;
    padding: 0 18px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .copyright-documents {
    &-block {
      &-content {
        margin-top: 20px;
        &-list {
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .ipub-block_font-downloading {
    width: 153px;
    height: 5px;
    &-content {
      width: 0;
      height: 100%;
      background: $main_color_l;
      transition: 0.3s all;
    }
  }
}
</style>
